import { faTimes, faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { yupResolver } from '@hookform/resolvers/yup';
import React, { useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { i18n } from 'src/i18n';
import yupFormSchemas from 'src/modules/shared/yup/yupFormSchemas';
import InputFormItem from 'src/view/shared/form/items/InputFormItem';
import CheckboxFormItem from 'src/view/shared/form/items/CheckboxFormItem';
// import AppAutocompleteFormItem from 'src/view/app/autocomplete/AppAutocompleteFormItem';
import * as yup from 'yup';
import TextAreaFormItem from 'src/view/shared/form/items/TextAreaFormItem';

const schema = yup.object().shape({
  name: yupFormSchemas
    .string(i18n('entities.prompt.fields.name'), {})
    .required(),
  // description: yupFormSchemas.string(
  //   i18n('entities.prompt.fields.description'),
  //   {}
  // ),
  whoAmI: yupFormSchemas
    .string(i18n('entities.prompt.fields.whoAmI'), {})
    .required(),
  withWhom: yupFormSchemas
    .string(i18n('entities.prompt.fields.withWhom'), {})
    .required(),
  topic: yupFormSchemas
    .string(i18n('entities.prompt.fields.topic'), {})
    .required(),
  // app: yupFormSchemas
  //   .relationToOne(i18n('entities.prompt.fields.app'), {})
  //   .required(),
  // prompt: yupFormSchemas
  //   .string(i18n('entities.prompt.fields.prompt'), {})
  //   .test(
  //     'params-validation',
  //     'The prompt text must contain parameters enclosed in square brackets.',
  //     (value) => {
  //       if (value) {
  //         // eslint-disable-next-line
  //         const regex = /\[(?=[^\[\]])(.*?)\]/g;
  //         const params = value.match(regex);
  //         if (!params || params.length === 0) {
  //           return false;
  //         }
  //       }
  //       return true;
  //     }
  //   )
  //   .required(),
  isPublic: yupFormSchemas.boolean(i18n('entities.prompt.fields.isPublic'), {}),
});

function PromptForm(props) {
  const { saveLoading } = props;
  const [initialValues] = useState(() => {
    const record = props.record || {};

    return {
      name: record.name,
      // description: record.description,
      // app: record.app,
      // prompt: record.prompt,
      whoAmI: record.whoAmI,
      withWhom: record.withWhom,
      topic: record.topic,
      isPublic: record.isPublic,
    };
  });

  const form = useForm({
    resolver: yupResolver(schema),
    mode: 'all',
    defaultValues: initialValues,
  });

  const onSubmit = (values) => {
    props.onSubmit(props.record?.id, values);
  };

  return (
    <FormProvider {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <div className='w-full sm:w-md md:w-md lg:w-md'>
          <InputFormItem
            name='name'
            label={i18n('entities.prompt.fields.name')}
            placeholder='Template Name'
            required={true}
            autoFocus
          />
        </div>
        {/* <div className='w-full mt-4 sm:w-md md:w-md lg:w-md'>
          <TextAreaFormItem
            name='description'
            label={i18n('entities.prompt.fields.description')}
            placeholder='Template description'
          />
        </div> */}
        <div className='w-full sm:w-md md:w-md lg:w-md'>
          <TextAreaFormItem
            name='whoAmI'
            label={i18n('entities.prompt.fields.whoAmI')}
            placeholder={i18n('entities.prompt.fields.whoAmI')}
            required={true}
          />
        </div>
        <div className='w-full sm:w-md md:w-md lg:w-md'>
          <TextAreaFormItem
            name='withWhom'
            label={i18n('entities.prompt.fields.withWhom')}
            placeholder={i18n('entities.prompt.fields.withWhom')}
            required={true}
          />
        </div>
        <div className='w-full sm:w-md md:w-md lg:w-md'>
          <TextAreaFormItem
            name='topic'
            label={i18n('entities.prompt.fields.topic')}
            placeholder={i18n('entities.prompt.fields.topic')}
            required={true}
          />
        </div>
        {/* <div className='w-full mt-4 sm:w-md md:w-md lg:w-md'>
          <TextAreaFormItem
            name='prompt'
            label={i18n('entities.prompt.fields.prompt')}
            placeholder='Prompt text and placeholders [KEYWORD] would be replaced automatically'
            required={true}
          />
        </div> */}
        {/* <div className="w-full mt-4 sm:w-md md:w-md lg:w-md">
          <AppAutocompleteFormItem  
            name="app"
            label={i18n('entities.prompt.fields.app')}
            required={true}
            placeholder="Select the app"
            showCreate={!props.modal}
          />
        </div> */}
        <div className='w-full mt-4 sm:w-md md:w-md lg:w-md'>
          <CheckboxFormItem name='isPublic' label='Make this prompt public' />
        </div>

        <div className='flex justify-center pt-4'>
          {props.onCancel ? (
            <button
              disabled={saveLoading}
              onClick={() => props.onCancel()}
              className='inline-block px-5 py-2 my-2 mr-6 text-sm text-white border border-white rounded-md hover:bg-gray-300 focus:outline-none dark:hover:text-black'
              type='button'
            >
              {i18n('common.close')}

              <FontAwesomeIcon className='ml-2' icon={faTimes} />
            </button>
          ) : null}
          <button
            className='inline-block border-green-500 border-2 rounded-md px-4 py-2 my-2 mr-4 text-sm text-green-500 hover:text-white hover:bg-green-500 focus:outline-none focus:border-green-500'
            disabled={saveLoading}
            type='button'
            onClick={form.handleSubmit(onSubmit)}
          >
            {i18n('common.save')}
            <FontAwesomeIcon
              className='ml-2'
              // icon={saveLoading ? faSpinner : faSave}
              // spin={saveLoading}
              icon={faCheckCircle}
            />
          </button>
        </div>
      </form>
    </FormProvider>
  );
}

export default PromptForm;
